import * as React from 'react'
import { useSelector } from 'react-redux'
// eslint-disable-next-line
import { useMap } from '@vis.gl/react-google-maps/dist/index.umd.js'

export default function VehicleRouteTwo() {
  return <PolylineOverlay />
}

const PolylineOverlay = () => {
  const map = useMap()
  const { selectedRoute, routeShape } = useSelector((s) => s.maps)

  // Track an array of polylines instead of just one
  const [polylines, setPolylines] = React.useState([])

  // Helper function to clear existing lines from the map
  const clearPolylines = React.useCallback(() => {
    polylines.forEach((line) => line.setMap(null))
    setPolylines([])
  }, [polylines])

  React.useEffect(() => {
    if (!map || typeof window === 'undefined' || !window.google) return

    // Scenario 1: No route selected, or route changed -> clear out old lines
    if (!selectedRoute || routeShape.length === 0) {
      if (polylines.length > 0) {
        clearPolylines()
      }
      return
    }

    // Scenario 2: Draw or update polylines if shape exists
    if (selectedRoute && routeShape.length > 0) {
      // Clear previous lines before drawing the new set
      polylines.forEach((line) => line.setMap(null))

      const strokeColor = selectedRoute.route_color || '#cc0033'

      // Map each GeoJSON feature to its own distinct Google Maps Polyline
      const newPolylines = routeShape.map((feature) => {
        const path = feature.geometry.coordinates.map(
          ([lng, lat]) => new window.google.maps.LatLng(lat, lng),
        )

        return new window.google.maps.Polyline({
          path,
          strokeColor,
          strokeOpacity: 0.8,
          strokeWeight: 3,
          editable: false,
          zIndex: 1,
          map,
        })
      })

      setPolylines(newPolylines)
    }

    // Cleanup hook on unmount
    // eslint-disable-next-line
    return () => {
      polylines.forEach((line) => line.setMap(null))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, routeShape, selectedRoute])

  return null
}
